import { render, staticRenderFns } from "./invitedUserRegistration.vue?vue&type=template&id=0aa4b987"
import script from "./invitedUserRegistration.vue?vue&type=script&lang=js"
export * from "./invitedUserRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports